export default "__VITE_ASSET__DvmeRiGX__"